import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FileXml"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18 15.75V6.75H16.5V17.25H22.5V15.75H18ZM13.5 6.75L12.36 10.5L12 11.985L11.655 10.5L10.5 6.75H9V17.25H10.5V11.25L10.38 9.75L10.815 11.25L12 14.7225L13.185 11.25L13.62 9.75L13.5 11.25V17.25H15V6.75H13.5ZM7.5 6.75H6L4.5 11.25L3 6.75H1.5L3.5625 12L1.5 17.25H3L4.5 12.75L6 17.25H7.5L5.4375 12L7.5 6.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FileXml.vue"]]);
